import React from 'react'
import './UpsellPopUp.css'
import { translate } from '../../../../utils/translator'

const BulletDot = () => (
  <span className="mr-2 text-[8px] leading-5">•</span>
)

const CheckIconGreen = () => (
  <svg className="shrink-0 w-[18px] h-[18px]" fill="none" viewBox="0 0 24 24">
    <path stroke="url(#checkGradientServiceDesktop)" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
  </svg>
)

interface ServiceSectionDesktopProps {
  premiumPrice: number;
  regularPrice: number;
  savingsAmount?: number;
  isPremiumCheaper?: boolean;
  language?: string;
}

export default function ServiceSectionDesktop({ premiumPrice, regularPrice, savingsAmount = 0, isPremiumCheaper = false, language }: ServiceSectionDesktopProps) {
  const t = (key: string) => translate(language, "shipping", `UpsellPopUpV2/${key}`) as string;

  return (
    <div id="upgrade-order-modal-service-cards" className="flex flex-col gap-4 mb-4">
      <svg width={0} height={0} className="absolute">
        <defs>
          <linearGradient id="checkGradientServiceDesktop" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#16A34A" />
            <stop offset="100%" stopColor="#59CE3B" />
          </linearGradient>
        </defs>
      </svg>

      {/* Ihre aktuelle Wahl */}
      <div className="relative mt-2.5 p-1 rounded-[20px] border border-gray-300 bg-[#C5C5C5]">
        <span className="block font-poppins text-[15px] font-medium text-white pl-3 pt-0.5 pb-1.5">
          {t("current_choice_label")}
        </span>

        <div
          id="regular-service-card"
          className="w-full rounded-2xl bg-white upsell-v2-card-border pt-6 px-6 pb-5"
        >
          <div className="flex justify-between items-start mb-3">
            <div>
              <h3 className="font-poppins font-semibold text-2xl text-black mb-0.5">
                {t("desktop_regular_title")}
              </h3>
              <p className="font-poppins text-[13px] text-black">
                {t("desktop_regular_description")}
              </p>
            </div>
            <div className="text-right shrink-0 ml-4">
              <p className="font-poppins font-semibold text-[25px] text-[#9D9D9D]">
                ~{regularPrice.toFixed(2).replace('.', ',')} €
              </p>
              <p className="font-poppins text-[13px] text-black">
                {t("desktop_regular_price_label")}
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-1 rounded-b-[14.5px] -mx-6 -mb-5 px-6 pb-[19px] pt-3 bg-[#F9F9F9]">
            <div className="flex items-center">
              <BulletDot />
              <span className="font-poppins text-[13px] text-black">{t("desktop_regular_bullet_pharmacy")}</span>
            </div>
            <div className="flex items-center">
              <BulletDot />
              <span className="font-poppins text-[13px] text-black">{t("desktop_regular_bullet_stock")}</span>
            </div>
            <div className="flex items-center">
              <BulletDot />
              <span className="font-poppins text-[13px] text-black">{t("desktop_regular_bullet_price")}</span>
            </div>
          </div>
        </div>
      </div>

      {isPremiumCheaper && savingsAmount > 0 && (
        <div
          className="mx-auto text-center w-[353px] h-10 rounded-2xl p-3 bg-white flex items-center justify-center -mt-[25px] -mb-5 z-[2] relative shadow-[0px_0px_8px_0px_rgba(0,0,0,0.12)] gap-2.5"
        >
          <p className="font-poppins text-[13px] text-black font-medium m-0">
            {t("desktop_savings_badge_prefix")}{' '}
            <span className="font-semibold text-[#62AE49]">
              ca.{savingsAmount.toFixed(0)} €
            </span>
            {' '}{t("desktop_savings_badge_suffix")}
          </p>
        </div>
      )}

      {/* Unsere Empfehlung */}
      <div
        className={`relative p-1 rounded-[20px] border border-[#15967C] upsell-v2-recommendation-gradient ${isPremiumCheaper && savingsAmount > 0 ? 'mt-0' : 'mt-2.5'}`}
      >
        <div className="flex justify-between items-center px-3 pt-0.5 pb-1.5">
          <span className="font-poppins text-[15px] font-medium text-white">
            {t("recommendation_label")}
          </span>
          <span className="font-poppins text-[13px] font-semibold italic text-white bg-[#006524] rounded-md px-2.5 py-0.5">
            {t("desktop_best_value")}
          </span>
        </div>

        <div
          id="premium-service-card"
          className="rounded-2xl bg-white border-2 border-[#15967C] pt-6 px-6 pb-5"
        >
          <div className="flex justify-between items-start mb-1">
            <div>
              <h3
                className="font-poppins font-semibold text-2xl upsell-v2-title-gradient mb-0.5"
              >
                {t("desktop_premium_title")}
              </h3>
              <p className="font-poppins text-[13px] text-black">
                {t("desktop_premium_description")}
              </p>
            </div>
            <div className="text-right shrink-0 ml-4">
              <p
                className="font-poppins font-semibold text-[25px] upsell-v2-price-gradient"
              >
                {premiumPrice.toFixed(2).replace('.', ',')} €
              </p>
              <p className="font-poppins text-[13px] font-medium text-black">
                {t("desktop_premium_price_label")}
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-1 rounded-b-[14.5px] -mx-6 -mb-5 px-6 pb-[19px] pt-3 bg-[#F9F9F9]">
            <div className="flex items-start gap-2">
              <CheckIconGreen />
              <span className="font-poppins text-[13px] text-black">
                {t("desktop_premium_bullet_delivery")}
              </span>
            </div>
            <div className="flex items-start gap-2">
              <CheckIconGreen />
              <span className="font-poppins text-[13px] text-black">
                {t("desktop_premium_bullet_stock")}
              </span>
            </div>
            <div className="flex items-start gap-2">
              <CheckIconGreen />
              <span className="font-poppins text-[13px] text-black">
                {t("desktop_premium_bullet_support")}
              </span>
            </div>
            <div className="flex items-start gap-2">
              <CheckIconGreen />
              <span className="font-poppins text-[13px] text-black">
                {t("desktop_premium_bullet_cannabis_id")}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
